import Theme from 'Theme';
import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

const baseStyles = {
    container: {
        marginHorizontal: Theme.primaryMargin
    },
    outerContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: Device.isTabletOrWeb ? 27 : 0
    },
    infoItemText: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: Theme.fontSizes.description,
        paddingRight: 20,
        flexShrink: 1,
        paddingVertical: 15,
        paddingLeft: 12,
        width: '100%'
    },
    sectionItemSelected: {
        backgroundColor: '#4e5758'
    },
    sectionItemText: {
        color: Theme.primaryTextColor,
        fontSize: 15
    }
};

export default StyleSheet.create(baseStyles);
